<template>
  <div class="groupsPrdtListing">
    <header>
      <div class="upper-header">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="16"
          viewBox="0 0 20 16"
          @click="goBack()"
        >
          <g fill="#000" fill-rule="evenodd">
            <path
              d="M18.2 6.72c.591 0 1.07.501 1.07 1.12 0 .619-.479 1.12-1.07 1.12H1.07C.48 8.96 0 8.459 0 7.84c0-.619.48-1.12 1.07-1.12H18.2z"
            />
            <path
              d="M2.585 7.84l5.666 5.928a1.157 1.157 0 0 1 0 1.584 1.038 1.038 0 0 1-1.514 0L.314 8.632a1.157 1.157 0 0 1 0-1.584L6.737.328a1.038 1.038 0 0 1 1.514 0 1.157 1.157 0 0 1 0 1.584L2.585 7.84z"
            />
          </g>
        </svg>
        <router-link :to="{path: '/bidding-winner-list'}" tag="div" class="winner-button">
          <img src="../../assets/images/detail/crowns.svg" />
          &nbsp; {{$t('ourWinners')}}
        </router-link>
      </div>
      <ul class="top-header">
        
        <!-- <li :class="{'active': (biddingStatus == 'running_mpoints_bid')}">
          <input
            type="radio"
            id="test2"
            name="radio-group"
            value="running_mpoints_bid"
            v-model="biddingStatus"
            @change="changeStatus('running_mpoints_bid')"
          />
          <label for="test2">{{$t('runningMpointsBids')}}</label>
        </li> -->
        <li :class="{'active': (biddingStatus == 'running_gems_bid')}">
          <input
            type="radio"
            id="test1"
            name="radio-group"
            value="running_gems_bid"
            v-model="biddingStatus"
            @change="changeStatus('running_gems_bid')"
          />
          <label for="test1">{{$t('runningGemsBids')}}</label>
        </li>
        <li :class="{'active': (biddingStatus == 'closed_bid')}">
          <input
            type="radio"
            id="test3"
            name="radio-group"
            value="closed_bid"
            v-model="biddingStatus"
            @change="changeStatus('closed_bid')"
          />
          <label for="test3">{{$t('closedBids')}}</label>
        </li>
        <li :class="{'active': (biddingStatus == 'my_bid')}">
          <input
            type="radio"
            id="test4"
            name="radio-group"
            value="my_bid"
            v-model="biddingStatus"
            @change="changeStatus('my_bid')"
          />
          <label for="test4">{{$t('myBids')}}</label>
        </li>
      </ul>
    </header>

    <section class="detail_content">      
      <!-- <RunningBids v-if="biddingStatus ==='running_mpoints_bid'" /> -->
      <RunningGemsBid v-if="biddingStatus ==='running_gems_bid'" />
      <ClosedBids v-if="biddingStatus ==='closed_bid'" />
      <MyBids v-if="biddingStatus ==='my_bid'" />
    </section>
  </div>
</template>

<script>
import NoDataFound from "../../components/Common/NoDataFound";
import ApiCaller from "../../utils/apicaller";
import constant from "../../utils/constant";
import RunningGemsBid from "../ShoppingGame/Bidding/RunningGemsBid";
import RunningBids from "../ShoppingGame/Bidding/RunningBids";
import ClosedBids from "../ShoppingGame/Bidding/ClosedBids";
import MyBids from "../ShoppingGame/Bidding/MyBids";
export default {
  name: "BiddingProductListing",
  components: {
    NoDataFound,
    RunningGemsBid,
    RunningBids,
    ClosedBids,
    MyBids
  },
  data() {
    return {
      biddingStatus: "running_status",
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    changeStatus(Status) {
      this.$cookie.set("biddingStatus", Status);
      if (this.$cookie.get("biddingStatus") == "running_gems_bid") {
        this.biddingStatus = "running_gems_bid";
      } else if(this.$cookie.get("biddingStatus") == "running_mpoints_bid") {
        this.biddingStatus = "running_mpoints_bid";
      } else if (this.$cookie.get("biddingStatus") == "closed_bid") {
        this.biddingStatus = "closed_bid";
      }else if (this.$cookie.get("biddingStatus") == "my_bid") {
        this.biddingStatus = "my_bid";
      }
    },
  },
  mounted() {
    this.biddingStatus = this.$cookie.get("biddingStatus");
    if (this.biddingStatus == null) {
      this.biddingStatus = "running_gems_bid";
    }
  }
};
</script>
<style scoped lang="scss">

header {
  position: fixed;
  top: 0;
  z-index: 9;
  border-bottom: 1px solid #e8e8e8;
  background: #fff;
  .upper-header {
    display: flex;
    justify-content: space-between;
    padding: 15px;
    align-items: center;
  }
  .winner-button {
    border: 1.3px solid #ff4b00;
    width: fit-content;
    padding: 5px 10px;
    border-radius: 5px;
    color: #ff4b00;
    font-weight: 600;
    display: flex;
    align-items: center;
    font-family: "Roboto", sans-serif;
  }
  .top-header {
    width: 100%;
    display: flex;
    align-items: center;
    overflow: scroll;
  }
  .top-header li {
    width: inherit;
    padding: 0 15px;
    border-bottom: 4px solid transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 55px;
    // flex-grow: 1;
    font-size: 0.938em;
    text-align: center;
    input{
      display: none;
    }
  }
  .top-header li.active {
    border-bottom-color: #e81f1f;
    color: #e81f1f;
    font-weight: 500;
  }
}
.detail_content {
  padding: 114px 0 20px;
}
</style>
    